import { Avatar } from "antd";
import { getColorByObjectId } from "../common/helpers";
import AdminChatIcon from "./icons/AdminChatIcon";
import dayjs from "dayjs";
import { DATE_FORMAT_HH_mm_A } from "../constants/constants";
import InfoIcon from "./icons/InfoIcon";
import { motion } from "framer-motion";


interface Props {
    data: any;
    prevUser: string
    viewInfo: (info: any) => void;
}
const ChatItem = (props: Props) => {
    const { data, prevUser, viewInfo } = props;
    return (
        <div className="flex gap-x-[8px]">
            {prevUser !== data?.user ? data?.user === "admin" ? (
                <AdminChatIcon />
            ) : (
                data?.user !== "self" ? (
                    <Avatar className="!w-[32px]" style={getColorByObjectId(data?.senderUserID)}>{data?.senderName?.charAt(0)?.toUpperCase()}</Avatar>
                ) : (
                    <></>
                )
            ) : (
                data?.user !== "self" ? (
                    <div className="w-[32px]" />
                ) : (
                    <></>
                )

            )}

            <motion.div
                initial={{ opacity: 0, x: data?.user === "self" ? 8 : -8, y: data?.user === "self" ? 8 : -8 }}
                animate={{ opacity: 1, x: 0, y: 0 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                className={`${data?.user === "self"
                    ? "self-end bg-[#344054] text-white ml-[180px]"
                    : "self-start bg-[#FFFFFF] mr-[180px]"
                    } text-[13px] p-[12px] rounded-[4px] flex-1 flex flex-col gap-y-[12px] min-w-[200px]`}
            >
                <p className="text-[12px] m-0">{data?.message}</p>
                <div className="flex items-center gap-x-[4px] justify-end">
                    <p className={`text-[10px] m-0 self-end ${data?.user == "self" ? "text-white" : "text-[#667085]"}`}>{dayjs(data?.date).format(DATE_FORMAT_HH_mm_A)}</p>
                    {data?.user === "self" ? (
                        <div className={`cursor-pointer p-[2px] rounded-[20px] ${data?.user == "self" ? "hover:bg-[#4B5563]" : "hover:bg-[#FAFAFA]"}`} onClick={() => viewInfo(data)}>
                            <InfoIcon size={13} color={data?.user == "self" ? "white" : "#667085"} />
                        </div>
                    ) : (
                        <></>
                    )}

                </div>

            </motion.div>
        </div>

    )
}

export default ChatItem